import { render, staticRenderFns } from "./GsLocaleSelector.vue?vue&type=template&id=7051b1ec&"
import script from "./GsLocaleSelector.vue?vue&type=script&lang=js&"
export * from "./GsLocaleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports